import { render } from "./CytogeneticsReport.vue?vue&type=template&id=cff31492&scoped=true"
import script from "./CytogeneticsReport.vue?vue&type=script&lang=js"
export * from "./CytogeneticsReport.vue?vue&type=script&lang=js"

import "./CytogeneticsReport.vue?vue&type=style&index=0&id=cff31492&lang=scss&scoped=true"
import "./CytogeneticsReport.vue?vue&type=style&index=1&id=cff31492&lang=scss"
import "./CytogeneticsReport.vue?vue&type=style&index=2&id=cff31492&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff31492"]])

export default __exports__